export var magicLinkContextDefaultValue = {
    magic: undefined,
    isMagicLoggedIn: false,
    isMagicLoggedInWithUser: false,
    reconnectMagicLink: function (_userAddress) { return Promise.resolve(undefined); },
    loginWithMagicLink: function (_email) { return Promise.resolve(''); },
    showOtpDialog: false,
    showDeviceMessage: false,
    loading: false,
    errorMessage: undefined,
};
